// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","container":"Loading_container__8fuVK","lotus":"Loading_lotus__PBYuN","spin":"Loading_spin__grgdF","label":"Loading_label__sVQXv"};